import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const SoftwareTabContent = () => {
    const intl = useIntl();

    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.software.card.linkText",
        defaultMessage: "Try it out"
    });

    const cardDataEventProps: DataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };

    return (
        <TabsContent
            className="homepage-tabs-content"
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.header",
                        defaultMessage: "Supercharge dev productivity"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.bodytext",
                        defaultMessage:
                            "Plan, track, and release world-class software with the number one software development tool for agile teams"
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.learnMore",
                    defaultMessage: "Learn more about Software"
                }),
                link: useLocalizedHref("/teams/software-development"),
                linkLabel: "Learn more about Software",
                productKey: "home"
            }}
            pictureProps={{
                image: {
                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-main.webp",
                    alt: "",
                    height: 400,
                    width: 768
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "HomePageTemplateV2.tab.software.tabContentEyebrowText",
                defaultMessage: "Get started with a template"
            })}
            cardsContent={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card1.headerText",
                        defaultMessage: "Scrum"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card1.bodyText",
                        defaultMessage:
                            "Easily plan, track, and manage work across sprints"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: useLocalizedHref(
                                "/software/jira/templates/scrum"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-1.webp",
                            // TODO: add alt text here or just decorative?
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card2.headerText",
                        defaultMessage: "Bug Tracking"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card2.bodyText",
                        defaultMessage:
                            "Seamlessly report, track, and prioritize bugs to address development issues"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: useLocalizedHref(
                                "/software/jira/templates/bug-tracking"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-2.webp",
                            // TODO: add alt txt or image just decorative?
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card3.headerText",
                        defaultMessage: "DevOps"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card3.bodyText",
                        defaultMessage:
                            "Develop, deploy, and manage applications with an open tools approach"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: useLocalizedHref(
                                "/software/jira/templates/devops"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-3.webp",
                            // TODO: add alt txt or image just decorative?
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                }
            ]}
        />
    );
};

export { SoftwareTabContent };
